import { apiHost } from '../../../config';
import { deleteRequest } from '../../requests';

export default async function deleteSchool(id: number) {
  return deleteRequest(`${apiHost}/api/admin/schools/${id}`);
}
